$shm_hitalama_vk_analysis $mol_list
	title \Сбор и анализ постов
	token null $shm_hitalama_vk_token
	token_str \
	No_auth_message $mol_text
		text \Выберите пользователя
	collect_queue? /string
	auto / <= auto_collect null
	collect_pending false
	sub /
		<= Section $mol_section
			title <= title
		^ group_body /
			<= Collect_block $mol_view
				sub /
					<= Search $shm_hitalama_vk_group_search
						reset => search_reset
						search_label /$mol_view_content
							<= search_title \Введите ссылку на сообщество
							<= List_select $mol_select
								trigger_content / \выберите список
								dictionary <= lists_dict *
								value? <=> selected_list_link? \
						search_click <= cancel_select_list null
						token_str <= token_str
						owner_id => search_owner_id
						dto => search_dto
						buttons / ^ collect_button /
							<= Collect $mol_button_major
								title \Собрать посты
								click? <=> collect? null
							<= Cancel $mol_button_major
								title \Отмена
								click? <=> collect_cancel? null
					^ list_view /
						<= List $mol_view
							sub / 
								<= List_name $mol_text
									text <= selected_list_name \
								^ collect_button
			^ analysis /
				<= Summary_label $mol_labeler
					title \Сводные показатели
					content /
						<= Summary $shm_hitalama_vk_analysis_summary
							token_str <= token_str
							owner_ids <= owner_ids /
							posts_dto_by_owner* <= posts_dto_by_owner*
				<= Posts_deck $mol_deck
					items /
						<= Posts_table $shm_hitalama_vk_posts_table
							title \Таблица постов
							owner_ids <= owner_ids /
							Posts_by_owner* <= Posts_by_owner*
						<= Plots $shm_hitalama_vk_posts_plots
							title \Графики
							owner_ids <= owner_ids /
							group_name* <= group_name* \
							Posts_by_owner* <= Posts_by_owner*
	Loaders $mol_list
		sub / <= Loader*0 $mol_list
			sub /
				<= Loader_message* $mol_paragraph
					title <= loader_message* \Идет сбор постов
					- \Идет сбор постов из {name}
				- <= Loader_result* $mol_paragraph
					title <= loader_result* \Данные собрали за {sec} сек, количество постов: {count}
	Posts_by_owner* $shm_hitalama_vk_posts
		token_str <= token_str
		owner_id? <=> owner_id*? \
		collect? => collect_by_owner*?
		dto => posts_dto_by_owner*
		pending => posts_pending*
